var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React from 'react';
import { actions as formActions } from 'react-redux-form';

import templatesAPI from "./TemplatesAPI";
import thesauriAPI from "../Thesauri/ThesauriAPI";
import relationTypesAPI from "../RelationTypes/RelationTypesAPI";
import TemplateCreator from "./components/TemplateCreator";
import { actions } from "../BasicReducer";
import RouteHandler from "../App/RouteHandler";
import { OnTemplateLoaded } from "./components/OnTemplateLoaded";
import { prepareTemplate } from "./actions/templateActions";

export default class EditTemplate extends RouteHandler {
  static async requestState(requestParams) {
    const { templateId } = requestParams.data;
    const [templates, thesauris, relationTypes] = await Promise.all([
    templatesAPI.get(requestParams.onlyHeaders()),
    thesauriAPI.get(requestParams.onlyHeaders()),
    relationTypesAPI.get(requestParams.onlyHeaders())]);


    const template = templates.find((tmpl) => tmpl._id === templateId);

    return [
    formActions.load('template.data', prepareTemplate(template)),
    actions.set('thesauris', thesauris),
    actions.set('templates', templates),
    actions.set('relationTypes', relationTypes)];

  }

  componentDidMount() {
    this.context.store.dispatch(formActions.reset('template.data'));
  }

  render() {
    return /*#__PURE__*/(
      _jsx("div", { className: "settings-content sm-footer-extra-row" }, void 0, /*#__PURE__*/
      _jsx(OnTemplateLoaded, {}, void 0, /*#__PURE__*/
      _jsx(TemplateCreator, {}))));



  }
}